import { Helper } from "../../utils/Helper";
import { Presentation, PresentationState } from "./Presentation";
import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { GameModel } from "@nolimitcity/slot-game/bin/model/GameModel";
import { FlowStateController } from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import { FlowStatePresentation } from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { APIEvent } from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {  gsap } from "gsap";

export class PresentationController implements FlowStatePresentation {

    private timeline: gsap.core.Timeline;

    private dataModel: GameModel<any, any>;

    private presentations: Presentation[] = [];

    private presentation: Presentation | undefined;

    private flowStateController: FlowStateController;

    private modeState:string;

    private get GameData(): any {
        return this.dataModel.gameData;
    }

    private get InitData(): any {
        return this.dataModel.initData;
    }

    constructor(_presentations: Presentation[], _model: GameModel<any, any>, _modeState:string) {
        this.dataModel = _model;
        this.presentations = _presentations;
        this.modeState = _modeState;
    }

    public InitPresentations(): void {
        this.presentations.forEach(p => {
            p.setInitData && this.InitData.mode === this.modeState && p.setInitData(this.InitData);
            p.initialization && p.initialization();
        });
    }

    // Give data to all presentations in the list for activation evaluation.
    public start(flowStateController: FlowStateController): void {
        this.flowStateController = flowStateController;

        this.checkAndParseData();
        this.tryPlayNextPresentation();
    }

    private checkAndParseData(): void {
        
        for (let i: number = 0; i < this.presentations.length; i++) {
            const presentation: Presentation = this.presentations[i];
            if (presentation.checkForActivation(this.GameData ? this.GameData : this.InitData)) {
                // Sets the presentation state to activated due to it passed the check.
                presentation.PresentationState.set(PresentationState.ACTIVATED);
                presentation.setGamedData && this.GameData && presentation.setGamedData(this.GameData);
            };
        }
    }

    private tryPlayNextPresentation():void{
        this.findActive() ? this.startPresentation() : this.finish();
    }

    /*****/
    // Playlist that is being called and managed in order.
    private startPresentation(): void {
        setTimeout(() => {
            this.timeline = Helper.setTimeline(this.timeline, new gsap.core.Timeline({
                paused: true,
                onComplete: () => this.recursive()
            }));

            this.presentation!.timeline = this.timeline;

            this.presentation!.createPresentation((enable: boolean) => this.enableSkip(enable));

            this.presentation!.timeline.totalDuration() ? this.presentation!.timeline.play() : this.recursive();
        });
    }

    private enableSkip(enable: boolean = true): void {
        this.flowStateController.setSkipCallback(enable ? () => {
            if (this.presentation) this.presentation.skip();
            else {
                Logger.log("Tried to skip but couldn't find " + (this.presentation ? "presentation" : "skip-method."))
            }
        } : undefined);

        // Stolen function from GameflowController. This one triggers the skip without animation.
        if (!enable) SlotGame.apiPlugin.events.trigger(APIEvent.SKIP);
    }

    // This is needed if we want to do an multiple state loop.
    private recursive(): void {
        if (!this.checkFinished() || this.checkIsStillActive()) {
            this.startPresentation();
        }
        else {
            this.triggerDone();
            this.tryPlayNextPresentation();
        }
    }

    private findActive(): Presentation | undefined {
        this.presentation = this.presentations.find((p: Presentation) => { return p.isActive(); });
        if (this.presentation && this.presentation.preStart) this.presentation.preStart();
        return this.presentation;
    }

    private checkFinished(): boolean { return this.presentation!.isFinished(); }

    private checkIsStillActive(): boolean { return this.presentation!.isActive(); }

    private triggerDone(): void { this.presentation!.done && this.presentation!.done(); }

    // Calls the manager for activating the callback when all presentations are done.
    private finish(): void {
        Logger.log("Finished Event State: " + this.flowStateController.state)
         this.flowStateController.finish();
        }
}